var map = {
	"./App": 7222,
	"./App.vue": 7222,
	"./assets/css/common.scss": 807,
	"./assets/css/global.scss": 3059,
	"./assets/css/reset.scss": 2841,
	"./assets/css/rtlang.scss": 2087,
	"./assets/css/utils.scss": 5955,
	"./assets/css/vtip.css": 6714,
	"./assets/fonts/Poppins-Bold.ttf": 3965,
	"./assets/fonts/Poppins-Medium.ttf": 7318,
	"./assets/fonts/Poppins-Regular.ttf": 7588,
	"./assets/fonts/Poppins-SemiBold.ttf": 8167,
	"./assets/fonts/font.css": 9399,
	"./assets/icons": 7258,
	"./assets/icons/": 7258,
	"./assets/icons/index": 7258,
	"./assets/icons/index.js": 7258,
	"./assets/icons/svg/icon-arrow.svg": 1089,
	"./assets/icons/svg/icon-back.svg": 5460,
	"./assets/icons/svg/icon-copy.svg": 4171,
	"./assets/icons/svg/icon-discord.svg": 9845,
	"./assets/icons/svg/icon-lang.svg": 7667,
	"./assets/icons/svg/icon-menu.svg": 5913,
	"./assets/icons/svg/icon-telegram.svg": 5810,
	"./assets/icons/svg/icon-x.svg": 6989,
	"./assets/icons/svg/icon-youtube.svg": 351,
	"./assets/images/Physical Card p.png": 4276,
	"./assets/images/Physical Card w p.png": 4160,
	"./assets/images/Physical Card w.mp4": 9210,
	"./assets/images/Physical Card.mp4": 9391,
	"./assets/images/Virtual Card p.png": 1458,
	"./assets/images/Virtual Card w p.png": 883,
	"./assets/images/Virtual Card w.mp4": 701,
	"./assets/images/Virtual Card.mp4": 5140,
	"./assets/images/api/hero-bg.jpg": 9868,
	"./assets/images/api/icon-bell.jpg": 6304,
	"./assets/images/api/icon-card.jpg": 3607,
	"./assets/images/api/icon-chart.jpg": 2342,
	"./assets/images/api/icon-padlock.jpg": 8024,
	"./assets/images/api/icon-receipt.jpg": 2989,
	"./assets/images/api/icon-sliders.jpg": 8482,
	"./assets/images/api/icon-wallet.jpg": 2507,
	"./assets/images/api/world-map.jpg": 4172,
	"./assets/images/icon-browser.png": 4385,
	"./assets/images/icon-line.png": 2812,
	"./assets/images/icon-telegram.png": 6795,
	"./assets/images/login-1.png": 2317,
	"./assets/images/login.png": 5567,
	"./assets/images/p1-bg.jpg": 6308,
	"./assets/images/p2-img-1.png": 8198,
	"./assets/images/p2-img-2.png": 9146,
	"./assets/images/p3-img-1.jpg": 367,
	"./assets/images/p3-img-2.jpg": 6701,
	"./assets/images/p4-img-1.jpg": 4737,
	"./assets/images/p4-img-2.jpg": 6973,
	"./assets/images/p4-img-3.jpg": 4429,
	"./assets/images/p4-img-4.jpg": 4443,
	"./assets/images/p4-img-5.jpg": 1389,
	"./assets/images/p4-img-6.jpg": 5367,
	"./assets/images/p5-img.jpg": 4976,
	"./assets/images/p5-img.png": 7579,
	"./assets/images/wap_p1-bg.jpg": 171,
	"./assets/images/wap_p3-img-1.jpg": 7782,
	"./assets/images/wap_p3-img-2.jpg": 7714,
	"./assets/images/wap_p4-img-1.jpg": 8450,
	"./assets/images/wap_p4-img-2.jpg": 5359,
	"./assets/images/wap_p4-img-3.jpg": 9445,
	"./assets/images/wap_p4-img-4.jpg": 3480,
	"./assets/images/wap_p4-img-5.jpg": 2159,
	"./assets/images/wap_p4-img-6.jpg": 1876,
	"./assets/js/noZoom": 2654,
	"./assets/js/noZoom.js": 2654,
	"./assets/js/rem": 9633,
	"./assets/js/rem.js": 9633,
	"./assets/js/requestApiCache": 1270,
	"./assets/js/requestApiCache.js": 1270,
	"./components/mHead": 264,
	"./components/mHead.vue": 264,
	"./components/mLang": 1606,
	"./components/mLang.vue": 1606,
	"./components/svgIcon": 7115,
	"./components/svgIcon.vue": 7115,
	"./directive": 973,
	"./directive/": 973,
	"./directive/direct/v-anchor": 2828,
	"./directive/direct/v-anchor.js": 2828,
	"./directive/direct/v-debounce": 4459,
	"./directive/direct/v-debounce.js": 4459,
	"./directive/direct/v-draggable": 2971,
	"./directive/direct/v-draggable.js": 2971,
	"./directive/direct/v-expand": 5472,
	"./directive/direct/v-expand.js": 5472,
	"./directive/direct/v-scroll": 7660,
	"./directive/direct/v-scroll.js": 7660,
	"./directive/direct/v-shuibowen": 3131,
	"./directive/direct/v-shuibowen.js": 3131,
	"./directive/index": 973,
	"./directive/index.js": 973,
	"./i18n": 6926,
	"./i18n/": 6926,
	"./i18n/i18nOption": 7292,
	"./i18n/i18nOption.json": 7292,
	"./i18n/index": 6926,
	"./i18n/index.js": 6926,
	"./i18n/json/am": 3947,
	"./i18n/json/am.json": 3947,
	"./i18n/json/ar": 8600,
	"./i18n/json/ar.json": 8600,
	"./i18n/json/bn": 7024,
	"./i18n/json/bn.json": 7024,
	"./i18n/json/cht": 7688,
	"./i18n/json/cht.json": 7688,
	"./i18n/json/de": 4173,
	"./i18n/json/de.json": 4173,
	"./i18n/json/en": 8380,
	"./i18n/json/en.json": 8380,
	"./i18n/json/es": 945,
	"./i18n/json/es.json": 945,
	"./i18n/json/fa": 6346,
	"./i18n/json/fa.json": 6346,
	"./i18n/json/fil": 9960,
	"./i18n/json/fil.json": 9960,
	"./i18n/json/fr": 7555,
	"./i18n/json/fr.json": 7555,
	"./i18n/json/hi": 7328,
	"./i18n/json/hi.json": 7328,
	"./i18n/json/id": 7618,
	"./i18n/json/id.json": 7618,
	"./i18n/json/my": 7567,
	"./i18n/json/my.json": 7567,
	"./i18n/json/nl": 8863,
	"./i18n/json/nl.json": 8863,
	"./i18n/json/pl": 4412,
	"./i18n/json/pl.json": 4412,
	"./i18n/json/pt": 2074,
	"./i18n/json/pt.json": 2074,
	"./i18n/json/ru": 1287,
	"./i18n/json/ru.json": 1287,
	"./i18n/json/tr": 2996,
	"./i18n/json/tr.json": 2996,
	"./i18n/json/uk": 5368,
	"./i18n/json/uk.json": 5368,
	"./i18n/json/ur": 3832,
	"./i18n/json/ur.json": 3832,
	"./i18n/json/vn": 6909,
	"./i18n/json/vn.json": 6909,
	"./main": 3217,
	"./main.js": 3217,
	"./router": 5092,
	"./router/": 5092,
	"./router/index": 5092,
	"./router/index.js": 5092,
	"./store": 8854,
	"./store/": 8854,
	"./store/index": 8854,
	"./store/index.js": 8854,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 3604,
	"./view/": 3604,
	"./view/api": 5072,
	"./view/api.vue": 5072,
	"./view/index": 3604,
	"./view/index.vue": 3604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;